module.exports = __webpack_public_path__ + "img/lLight.62d9122e.svg";